module.exports = __webpack_public_path__ + "fonts/GT-America-Expanded-Bold.b602be23.woff";